import React from 'react';
import {
  Button,
  Dialog,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
  useMediaQuery,
  Box,
} from '@mui/material';
import { useState } from 'react';
import { useTheme } from '@emotion/react';
import { GridExpandMoreIcon } from '@mui/x-data-grid';
import { Pendingwarning } from 'component/BuyersMarketplace/MakeOffers';
import { poppins400, poppins500, poppins700 } from 'theme/common.style';
import { AGENT_REMINDERSETTINGS } from 'constant/app.config';
import { postApiCall, formatDateTime } from 'api/apiService';
import Swal from 'sweetalert2';
import Loading from 'assets/images/loading.png';
import { useEffect } from 'react';

const Stage2Commence = ({
  openBox,
  setOpenBox,
  setOpenCommenceStageTwo,
  getListInfo,
  activityfun,
  offerdata,
  stageData,
  profileDetails,
  userDetail,
  stage2AcceptanceCertificate,
  setStage2AcceptanceCertificate,
}) => {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const [isLoading, setIsLoading] = useState(false);
  const [pauseTime, setPauseTime] = useState(0);
  const [zeropauseTime, setPauseTimeError] = useState(false);

  const handleClickCommenceStageTwo = () => {
    setOpenBox(false);
    setOpenCommenceStageTwo(true);
  };

  const [placeholder, setPlaceHolder] = useState(''); // Initialize with an empty string

  const handleChange = (e) => {
    let time = e.target.value;
    let [value, quantity] = time.split(' ');
    if (quantity == 'hours' || quantity == 'hour') {
      value = value * 60;
    }
    setPauseTime(parseInt(value));
    setPauseTimeError(false);
    setPlaceHolder(time);
    // Update state with the selected string value
  };

  const handleSubmit = async () => {
    let input = {
      propertyId: profileDetails?.PropertyDetails?.property?.propertyId,
      reminderType: 'Commence Stage2',
      reminderIn: pauseTime,
      isReminded: 0,
    };

    if (pauseTime === 0) {
      setPauseTimeError(true);
      return;
    } else {
      setPauseTime(false);
    }
    setIsLoading(true);
    try {
      const response = await postApiCall(AGENT_REMINDERSETTINGS, input);
      if (response?.data?.status === 1) {
        setOpenBox(false);
        getListInfo();
        Swal.fire({
          title: response?.data.heading,
          text: response?.data?.message,
          showDenyButton: false,
          showCancelButton: false,
          icon: 'success',
          confirmButtonText: 'Close',
        });
      } else {
        Swal.fire({
          title: response?.heading ? response?.heading : 'Failed',
          text: response?.data?.message || 'Something went wrong',
          showDenyButton: false,
          showCancelButton: false,
          icon: 'error',
          confirmButtonText: 'Close',
        }).then(() => {});
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (isLoading) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [isLoading]);

  const formatDateWithTime = (dateString) => {
    if (!dateString) return ''; // Handle undefined or null dates

    const date = new Date(dateString);

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();

    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  return (
    <Dialog
      open={openBox}
      slotProps={{
        root: {
          sx: { zIndex: 1 },
        },
      }}
      PaperProps={{
        sx: {
          borderRadius: '5px',
          minWidth: matchessm ? '100vw' : '400px',
          boxShadow: '-4px, 4px rgba(0, 0, 0, 0.09)',
          padding: matchessm ? '30px 20px' : '30px',
        },
      }}
    >
      <Grid container height={'100%'}>
        <Grid item xs={12}>
          <Typography
            sx={{
              ...poppins400,
              fontSize: matchessm ? '10px' : '14px',
              color: '#666666',
            }}
          >
            {' '}
            {stageData?.PropertyDetails?.propertyAddress?.streetName}
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          display={'flex'}
          alignItems={'center'}
          padding={'12px 0px 15px 0'}
        >
          <Pendingwarning />
          <Typography
            sx={{
              ...poppins500,
              fontSize: matchessm ? '16px' : '24px',
              paddingLeft: '12px',
            }}
          >
            Stage 2 – Commencement
          </Typography>
        </Grid>

        <Grid item xs={12} textAlign={'left'} marginBottom={'10px'}>
          <Typography
            sx={{
              ...poppins400,
              fontSize: matchessm ? '12px' : '16px',
              color: '#666666',
              display: 'flex',
              alignItems: 'center',
              display: 'inline',
            }}
          >
            Offer and acceptance has been received at{' '}
            <Typography component="span">
              <b
                style={{
                  fontFamily: 'Poppins',
                  fontWeight: 550,
                  color: '#666666',
                  fontSize: matchessm ? '12px' : '16px',
                }}
              >
                {formatDateTime(stageData?.firstAcceptedTimeDate)}
              </b>
            </Typography>{' '}
            for the{' '}
            <Typography component="span">
              <b
                style={{
                  fontFamily: 'Poppins',
                  fontWeight: 550,
                  color: '#666666',
                  fontSize: matchessm ? '12px' : '16px',
                }}
              >
                {stageData?.firstAcceptedOfferPrice}
              </b>
            </Typography>{' '}
            Offer.
          </Typography>
        </Grid>

        <Grid item xs={12} textAlign={'left'} marginBottom={'10px'}>
          <Typography
            sx={{
              ...poppins400,
              fontSize: matchessm ? '12px' : '16px',
              color: '#666666',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            Stage 2 can now commence.
          </Typography>
        </Grid>

        {/* Resume Campaign Section */}
        <Grid
          item
          xs={12}
          sm={4.5}
          textAlign={'left'}
          display={'flex'}
          alignItems={'center'}
        >
          <Typography
            sx={{
              ...poppins400,
              fontSize: matchessm ? '12px' : '16px',
              color: '#666666',
            }}
          >
            Reminder intervals:
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} textAlign={'left'}>
          <Select
            fullWidth
            disableUnderline
            required
            IconComponent={GridExpandMoreIcon}
            onChange={handleChange}
            value={placeholder} // Bind to state
            displayEmpty
            sx={{
              fontFamily: 'Poppins',
              fontStyle: 'normal !important',
              fontWeight: '300 !important',
              fontSize: matchessm ? '12px' : '14px',
              height: matchessm ? '28px' : '38px',
              alignItems: 'center',
              color: '#666666',
            }}
          >
            <MenuItem
              value=""
              disabled
              sx={{
                fontFamily: 'Poppins ',
                fontWeight: '300',
                fontSize: matchessm ? '12px' : '14px',
                minHeight: matchessm ? '0px' : '',
                display: 'none',
              }}
            >
              Select Reminder
            </MenuItem>
            <MenuItem
              value="30 minutes"
              sx={{
                fontFamily: 'Poppins ',
                fontWeight: '300',
                fontSize: matchessm ? '12px' : '14px',
                minHeight: matchessm ? '0px' : '',
              }}
            >
              30 minutes
            </MenuItem>
            <MenuItem
              value="1 hour"
              sx={{
                fontFamily: 'Poppins ',
                fontWeight: '300',
                fontSize: matchessm ? '12px' : '14px',
                minHeight: matchessm ? '0px' : '',
              }}
            >
              1 hour
            </MenuItem>
            <MenuItem
              value="6 hours"
              sx={{
                fontFamily: 'Poppins',
                fontWeight: '300',
                fontSize: matchessm ? '12px' : '14px',
                minHeight: matchessm ? '0px' : '',
              }}
            >
              6 hours
            </MenuItem>
            <MenuItem
              disabled={stageData?.isReminderSet24 === 1}
              value="24 hours"
              sx={{
                fontFamily: 'Poppins',
                fontWeight: '300',
                fontSize: matchessm ? '12px' : '14px',
                minHeight: matchessm ? '0px' : '',
              }}
            >
              24 hours
            </MenuItem>
          </Select>
        </Grid>

        {zeropauseTime && (
          <Grid
            item
            xs={6.2}
            md={8.1}
            sm={8.1}
            display={'flex'}
            justifyContent={'right'}
            mt={1}
          >
            <Typography
              sx={{ fontSize: '12px', fontFamily: 'poppins' }}
              variant="p"
              color={'error'}
            >
              Please select the reminder
            </Typography>
          </Grid>
        )}
        <Grid
          item
          container
          direction="row"
          sx={{ display: 'flex', alignItems: 'center' }}
          justifyContent={'flex-end'}
          gap={2}
          marginTop={matchessm ? '15px' : 5}
        >
          <Grid
            item
            sx={{ position: 'relative', display: 'flex', alignItems: 'center' }}
          >
            <Button
              variant="outlined"
              style={{
                padding: matchessm ? '6px 23px' : '10px 39px',
                fontSize: matchessm ? '12px' : '14px',
                color: '#666666',
                fontWeight: '400',
                fontFamily: 'Poppins',
                border: '1px solid rgba(17, 35, 71, 0.1)',
                borderRadius: '5px',
                textTransform: 'capitalize',
              }}
              onClick={handleSubmit}
              disabled={isLoading}
            >
              Remind me
            </Button>
            {isLoading && (
              <img
                alt="Loader"
                src={Loading}
                className="loaderImage"
                style={{
                  height: '40px',
                  width: '40px',
                  marginLeft: '10px',
                  display: 'inline-block',
                }}
              />
            )}
          </Grid>

          <Grid item>
            <Button
              variant="contained"
              style={{
                padding: matchessm ? '6px 23px' : '10px 39px',
                fontSize: matchessm ? '12px' : '14px',
                color: '#FFFFFF',
                fontWeight: '400',
                fontFamily: 'Poppins',
                background: '#4CA4D6',
                borderRadius: '5px',
                textTransform: 'capitalize',
              }}
              onClick={() => {
                handleClickCommenceStageTwo();
              }}
            >
              Commence
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default Stage2Commence;
